import { useState } from "react";
import { FinancialAnalysisSection } from "./FinancialAnalysis";
import { UnderWritingSummeryTable } from "./UnderWritingSummeryTable";

export const LeaseTables = () => {
  const [netOperatingIncome, setNetOperatingIncome] = useState(null);
  const [estimatedAssetValue, setEstimatedAssetValue] = useState(null);
  return (
    <>
      <FinancialAnalysisSection
        netOperatingIncome={netOperatingIncome}
        setNetOperatingIncome={setNetOperatingIncome}
        estimatedAssetValue={estimatedAssetValue}
        setEstimatedAssetValue={setEstimatedAssetValue}
      />
      <UnderWritingSummeryTable
        netOperatingIncome={netOperatingIncome}
        estimatedAssetValue={estimatedAssetValue}
      />
    </>
  );
};
